export const information = {
  site: "shbet",
  cskh_url: "https://shbetcskh01.pages.dev/",
  cskh_home: "https://shb27.com/trangchu",
  endpoint: "https://api-shbet.freecodevip.org",
  // endpoint: "http://localhost:5035",
  key_free: "att.code.free-code.sh-bet@2030$",
};